/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_SubmittedInputs */

const vi_einvoice_submitted = /** @type {(inputs: Einvoice_SubmittedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gửi yêu cầu xuất HĐĐT`)
};

/**

* @param {Einvoice_SubmittedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_submitted = /** @type {((inputs?: Einvoice_SubmittedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_SubmittedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_submitted(inputs)
});